import React from 'react'
import TestimonialDetail from '../testimonial_components/testimonial_detail'

export default function TestimonialDetailPage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <TestimonialDetail />
    </div>
  )
}
